import ComparisonSummary, {
	ComparisonSummaryParameters
} from './ComparisonSummary';
interface ComparisonSummaryEntityParameters<TEntityOld, TEntityNew = TEntityOld> extends ComparisonSummaryParameters<TEntityOld, TEntityNew> {
	id: string;
	descriptor: string;
	subDescriptor?: string;
	allowRemoval: boolean;
}

export default class ComparisonSummaryEntity<TEntityOld, TEntityNew = TEntityOld> extends ComparisonSummary<TEntityOld, TEntityNew> {
	public id: string;
	public descriptor: string;
	public subDescriptor: string | undefined;
	public allowRemoval: boolean;

	public constructor(params: ComparisonSummaryEntityParameters<TEntityOld, TEntityNew>) {
		super(params);

		this.id = params.id;
		this.descriptor = params.descriptor;
		this.subDescriptor = params.subDescriptor;
		this.allowRemoval = params.allowRemoval;
	}
}